import { useQuery } from '@tanstack/react-query'
import { fetchCoinAll } from '@api/common/api.js'
import { useOrgErrorPolicy } from '@hooks/useOrgErrorPolicy.js'
import { useOrgInfoStore } from '@store/common/useOrgInfoStore.js'
import { USE_TYPE } from '@constants/appTarget.js'
import { isAuthExpiredError } from '@utils/isAuthExpiredError.js'

const COIN_ALL_QUERY_KEY = ['coin-all']
const COIN_ALL_STALE_TIME = 1000 * 60 * 60 * 24

const HANA_COIN_ALL_RETRY_COUNT = 5
const HANA_COIN_ALL_RETRY_DELAY = 1000

const selectCoinAll = (data) => {
  return Array.isArray(data?.coins) ? data.coins : Object.values(data?.coins ?? {})
}

const queryCoinAll = () => fetchCoinAll()

// 인증 만료는 재시도 없이 바로 에러 처리
const retryHanaCoinAll = (failureCount, error) =>
  !isAuthExpiredError(error) && failureCount < HANA_COIN_ALL_RETRY_COUNT

export const useCoinAllQuery = ({ staleTime = COIN_ALL_STALE_TIME } = {}) => {
  const { throwOnError } = useOrgErrorPolicy()
  const isHana = useOrgInfoStore((s) => s.useType) === USE_TYPE.hana

  return useQuery({
    queryKey: COIN_ALL_QUERY_KEY,
    queryFn: queryCoinAll,
    select: selectCoinAll,
    staleTime,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    retry: isHana ? retryHanaCoinAll : false,
    retryDelay: HANA_COIN_ALL_RETRY_DELAY,
    throwOnError
  })
}

// 다시 시도 버튼용: 재시도 없이 1회만 호출
export const fetchCoinAllOnce = (queryClient) =>
  queryClient
    .fetchQuery({ queryKey: COIN_ALL_QUERY_KEY, queryFn: queryCoinAll, retry: false })
    .catch(() => {})
